import { api } from '@/constants'
import { getAuthHeader } from '@/util'
import baseURL from '@/service/api'

const aichat = {
    sendMessage: payloads => {
        const url = api.aichat.sendMessage
        return baseURL.post(url, payloads, { headers: getAuthHeader() })
    },

    getSessionHistories: () => {
        const url = api.aichat.getSessionHistories
        return baseURL.get(url, { headers: getAuthHeader() })
    },

    getMessages: sessionId => {
        const url = `${api.aichat.getMessages}/${sessionId}`
        return baseURL.get(url, { headers: getAuthHeader() })
    }
}
export default aichat
